import "regenerator-runtime/runtime";
import { put, call, takeEvery, takeLatest, all } from "redux-saga/effects";
import {
  createCustomOrder,
  getDefaultConfigs,
  submitDefaultConfigs,
  selectTrade
} from "./apis";
import * as CustomOrderAction from "./constants";
import * as NotifyActionType from "../Notification/constants";

export function* createCustomOrderAsync(action) {
  const result = yield call(createCustomOrder, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(result.data, true);
    }
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS,
      data: "Custom order created",
    });
  } else {
    if (action.callback) {
      action.callback(result.data, false);
    }
    yield [
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error }),
    ];
  }
}

export function* getDefaultConfigsAsync(action) {
  const result = yield call(getDefaultConfigs, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield[
      put({ type: CustomOrderAction.GET_DEFAULT_CONFIG_FOR_DROPDOWN_SUCCESS, data: result.data}),
    ]
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield [
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] }),
    ];
  }
}

export function* submitDefaultConfigsAsyn(action) {
  const result = yield call(submitDefaultConfigs, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(result.data);
    }
    yield put({
      type: NotifyActionType.NOTIFY_SUCCESS,
      data: "Configuration updated !",
    });
  } else {
    yield [
      put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] }),
    ];
  }
}

export function* selectTradeAsync(action) {
  const result = yield call(selectTrade, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: CustomOrderAction.SELECT_TRADE_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}
export default function* WatchDefaultConfig() {
  yield all([
    takeLatest(
      CustomOrderAction.CREATE_CUSTOM_ORDER_ASYNC,
      createCustomOrderAsync
    ),
    takeLatest(
      CustomOrderAction.GET_DEFAULT_CONFIG_FOR_DROPDOWN,
      getDefaultConfigsAsync
    ),
    takeLatest(
      CustomOrderAction.SUBMIT_DEFAULT_CONFIG,
      submitDefaultConfigsAsyn
    ),
    takeEvery(CustomOrderAction.SELECT_DEFAULT_CONFIG_TRADE_ASYNC, selectTradeAsync),

  ]);
}



// WEBPACK FOOTER //
// ./src/DefaultConfig/saga.js